import { writable } from 'svelte/store';

export const language = writable(localStorage.getItem('language') || 'sv');

language.subscribe((value) => localStorage.setItem('language', value));